import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Department } from 'store/departmentmanagementSlice';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface ViewDepartmentModalProps {
  show: boolean;
  handleClose: () => void;
  dept: Department;
}

const ViewDepartmentModal: React.FC<ViewDepartmentModalProps> = ({
  show,
  handleClose,
  dept
}) => {
  const { data: companies } = useSelector(
    (state: RootState) => state.companies
  );
  const { data: users } = useSelector((state: RootState) => state.users);

  const company = companies.find(c => c.id === dept.company_id);
  const headUser = users.find(u => u.id === dept.head_user_id);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fs-6">Department Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Basic Information
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Name</label>
              <div className="fs-6">{dept.name || '-'}</div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">
                Department Head
              </label>
              <div className="fs-6">
                {headUser
                  ? `${headUser.name} (${headUser.email})`
                  : dept.head_user_id === 0 || !dept.head_user_id
                  ? '-'
                  : `User #${dept.head_user_id}`}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Additional Information
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Company</label>
              <div className="fs-6">
                {company?.name || `Company #${dept.company_id}`}
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Created Date</label>
              <div className="fs-6">
                {dept.created_at
                  ? new Date(dept.created_at).toLocaleDateString()
                  : '-'}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top-0">
        <Button
          variant="phoenix-secondary"
          onClick={handleClose}
          className="px-4"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewDepartmentModal;
